import classnames from 'classnames/bind';
import { useTranslations } from 'next-intl';
import { RtText } from '@dpa/react-text';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'Copy-rights';

type TProps = {
  isOwnPaddings?: boolean;
};

export const CopyRights = ({ isOwnPaddings }: TProps) => {
  const translations = useTranslations('categories.footer');

  const text = translations('copyRights');

  return (
    <div
      className={cn(BLOCK_NAME, {
        [`${BLOCK_NAME}--own-paddings`]: isOwnPaddings,
      })}
    >
      <RtText
        className={cn(`${BLOCK_NAME}__text`)}
        specification="main"
        typography="body-xs-regular"
      >
        {text}
      </RtText>
    </div>
  );
};
